import { render, staticRenderFns } from "./PostWaiver.vue?vue&type=template&id=5f9b0bb6&scoped=true&"
import script from "./PostWaiver.vue?vue&type=script&lang=js&"
export * from "./PostWaiver.vue?vue&type=script&lang=js&"
import style0 from "./PostWaiver.vue?vue&type=style&index=0&id=5f9b0bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b0bb6",
  null
  
)

export default component.exports